import React from "react";
import {
  Box,
  Typography,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Grid,
  // useMediaQuery,
} from "@mui/material";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import optionChainImg from "backgroundImages/OptionChain.png";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

function OptionChainBox() {
  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down("sm"));

  const handleNavigation = (option, path) => {
    localStorage.setItem("page", option);
    window.location.href = path;
  };

  return (
    <Box
      style={{
        backgroundColor: "#dadada",
        padding: "1rem",
        borderRadius: "1rem",
        background: "rgba(218, 218, 218, 0.6)",
        border: "0.1rem solid #dadada",
        backdropFilter: "blur(3px)",
      }}
    >
      <Grid
        container
        style={{
          backgroundColor: "#ffffff",
          padding: "3rem  0.5rem 3rem 0.5rem",
          borderRadius: "1rem",
          border: "0.1rem solid #dadada",
          justifyContent: "space-around",
          display: "flex",
          alignContent: "center",
        }}
      >
            {/* <Grid
          item
          lg={12}
          sm={12}
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            textAlign: "center",
            alignItems: "center",
            marginBottom:"5vh"
          }}
        >
        
        </Grid> */}

        <Grid
          item
          lg={4}
          sm={12}
          display={"inline"}
          justifyContent={"center"}
          textAlign={smDown ? "center" : "left"}
          padding={"1rem"}
        >
          <Typography
            gutterBottom
            style={{
              color: "#000",
              fontWeight: "600",
              fontSize: "1rem",
              marginBottom: "1rem",
            }}
          >
            Option Chain
          </Typography>

          <Typography
            variant="body1"
            color="rgb(176, 184, 196)"
            fontSize={"0.8rem"}
            paragraph
          >
            Why Keep Switching Tabs?
            <br />
            With ChartingHQ’s Option Chain, everything you need to make informed
            trading decisions is now in one place. Analyze, compare, and
            trade—all on a single screen. It’s the ultimate tool for scalpers
            and intraday traders looking to stay ahead of the market.
          </Typography>
          <List>
            <ListItem>
              <CheckBoxIcon
                style={{
                  color: "#8E69FD",
                  height: "1rem",
                  marginRight: "0.5rem",
                }}
              />
              <Typography
                variant="body1"
                color="#000"
                fontSize={"0.8rem"}
                paragraph
              >
                Indices at a Glance: Analyze option chains for BANKNIFTY, NIFTY,
                and FINNIFTY with comprehensive indices and option charts.
              </Typography>

              <ListItemText primary="" />
            </ListItem>

            <ListItem>
              <CheckBoxIcon
                style={{
                  color: "#8E69FD",
                  height: "1rem",
                  marginRight: "0.5rem",
                }}
              />
              <Typography
                variant="body1"
                color="#000"
                fontSize={"0.8rem"}
                paragraph
              >
                Interactive Strike Selection: View Call and Put charts
                simultaneously for any selected strike, eliminating the need to
                switch tabs.
              </Typography>
            </ListItem>

            <ListItem>
              <CheckBoxIcon
                style={{
                  color: "#8E69FD",
                  height: "1rem",
                  marginRight: "0.5rem",
                }}
              />
              <Typography
                variant="body1"
                color="#000"
                fontSize={"0.8rem"}
                paragraph
              >
                Combined Strike Analysis: Create combined charts for selected
                strikes to compare data points effortlessly.
              </Typography>
            </ListItem>
          </List>

          <Button
            variant="contained"
            style={{
              color: "#fff",
              backgroundColor: "#000",
              fontSize: "0.8rem",
            }}
            mt={2}
            onClick={() => handleNavigation("oc", "/OptionChain")}
          >
            Access Option Chain
          </Button>
        </Grid>

        <Grid
          item
          lg={8}
          sm={12}
          display={"inline"}
          justifyContent={"center"}
          textAlign={smDown ? "center" : "left"}
    
        >
              <Box sx={{display:"flex", justifyContent:"center", marginBottom:"2rem", marginTop:"2rem", }}>
            {!smDown ? (
              <img
                src={optionChainImg}
                alt="ChartingHQ logo"
                style={{ height: "50vh", width: "50vw", border:"2px solid #000", borderRadius:"1rem"}}
              />
            ) : (
              <></>
            )}
          </Box>
          </Grid>
          

    
      </Grid>
    </Box>
  );
}

export default OptionChainBox;
